import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converte o status que vem do backend na variacao visual do badge
 * (classes definidas em src/styles/tables.css -> .carga-badge--<variacao>).
 *
 * Aceita tanto os status de cadastro (Ativo/Inativo) quanto os de
 * processamento (Status: PENDENTE, EM_ANDAMENTO, CONCLUIDO, AVISOS, FALHA,
 * CANCELADO) e as descricoes de acesso (Somente Leitura / Leitura e Gravacao).
 *
 * Uso: <span class="carga-badge" [ngClass]="'carga-badge--' + (valor | statusBadge)">
 */
@Pipe({ name: 'statusBadge' })
export class StatusBadgePipe implements PipeTransform {

  /** Status normalizado (maiusculo, sem acento) -> variacao do badge. */
  private static readonly VARIACOES: Record<string, string> = {
    // StatusCadastro (usuario/grupo)
    ATIVO: 'success',
    INATIVO: 'secondary',
    // Status (processamento de arquivo/lista/documento)
    PENDENTE: 'secondary',
    EM_ANDAMENTO: 'info',
    CONCLUIDO: 'success',
    AVISOS: 'warning',
    FALHA: 'danger',
    CANCELADO: 'secondary',
    // TipoAcesso
    SOMENTE_LEITURA: 'secondary',
    LEITURA_E_GRAVACAO: 'info'
  };

  transform(status?: string | null): string {
    if (!status) {
      return 'secondary';
    }

    const chave = String(status)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, '_');

    return StatusBadgePipe.VARIACOES[chave] ?? 'secondary';
  }
}
